// extracted by mini-css-extract-plugin
export default {"hint":"operationItemForm_hint__uDVmd","specialDiscount":"operationItemForm_specialDiscount__PTbQL"};